import Vue from 'vue'

const instance = new Vue({})
instance._$on = instance.$on
instance.$on = (event, fn) => {
  // if (instance._events[event]) {
  //   instance.$off(event);
  // }
  instance._$on(event, fn)
}
export default instance
